export default {"src":"/_next/static/media/menu-burger.0c3a4582.svg","height":24,"width":24};